import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useBottomPanelStore = defineStore('BottomPanel', () => {
  const component = ref(null)
  const inputFor = ref(null)
  const pickupPrefectures = ref([])
  const returnPrefectures = ref([])
  const searchAreasById = ref({})
  const searchAreas = ref([])
  const pickupShops = ref([])
  const returnShops = ref([])
  const displayList = ref('pickupPrefectures')
  const pickupTimeInfo = ref(null)
  const returnTimeInfo = ref(null)
  const maxKidAge = ref(12)

  function setBottomPanelInputFor(value) {
    inputFor.value = value
  }

  function setPickupPrefectures(value) {
    pickupPrefectures.value = value
  }

  function setSearchAreas(value) {
    searchAreas.value = value
  }

  function setSearchAreasById(value) {
    searchAreasById.value = value
  }

  function setReturnPrefectures(value) {
    returnPrefectures.value = value
  }

  function setPickupShops(value) {
    pickupShops.value = value
  }

  function setReturnShops(value) {
    returnShops.value = value
  }

  function setBottomPanelDisplayList(value) {
    displayList.value = value
  }

  function setPickupTimeInfo(value) {
    pickupTimeInfo.value = value
  }

  function setReturnTimeInfo(value) {
    returnTimeInfo.value = value
  }

  function setBottomPanelComponent(value = null) {
    component.value = value
  }

  function setMaxKidAge(value) {
    maxKidAge.value = value
  }

  return {
    component,
    inputFor,
    pickupPrefectures,
    returnPrefectures,
    searchAreasById,
    searchAreas,
    pickupShops,
    returnShops,
    displayList,
    pickupTimeInfo,
    returnTimeInfo,
    maxKidAge,
    setBottomPanelInputFor,
    setPickupPrefectures,
    setSearchAreas,
    setSearchAreasById,
    setReturnPrefectures,
    setPickupShops,
    setReturnShops,
    setBottomPanelDisplayList,
    setPickupTimeInfo,
    setReturnTimeInfo,
    setBottomPanelComponent,
    setMaxKidAge
  }
})
